import $ from 'jquery'
import {
  calculatePackageTotal,
  tourTimePriceUpdate,
  calculateExtraTotal,
  calculateExtraPackageTotal,
  calculateAllFee,
} from './price-function'

$(document).ready(function () {
  const $TourTimeInput = $('#tour-time')
  const $TourTimeMinusButton = $('.tour-time-minus')
  const $TourTimePlusButton = $('.tour-time-plus')

  const max_tour_time = parseInt($TourTimeInput.data('max-tour-time'))
  const minValue = 1
  const maxValue = max_tour_time

  $TourTimePlusButton.on('click', function (event) {
    event.preventDefault()
    let currentValue = parseInt($TourTimeInput.val()) || 1

    if (currentValue < maxValue) {
      currentValue += 1
      $TourTimeInput.val(currentValue)
    }

    if (currentValue === minValue + 1) {
      $TourTimeMinusButton.removeClass('disabled')
    }

    if (currentValue === maxValue) {
      $TourTimePlusButton.addClass('disabled')
    }
    tourTimePriceUpdate()
    calculatePackageTotal()
    calculateExtraTotal()
    calculateExtraPackageTotal()
    calculateAllFee()
  })

  $TourTimeMinusButton.on('click', function (event) {
    event.preventDefault()

    let currentValue = parseInt($TourTimeInput.val()) || 0
    if (currentValue > minValue) {
      currentValue -= 1
      $TourTimeInput.val(currentValue)
    }

    if (currentValue === maxValue - 1) {
      $TourTimePlusButton.removeClass('disabled')
    }

    if (currentValue === minValue) {
      $TourTimeMinusButton.addClass('disabled')
    }
    tourTimePriceUpdate()
    calculatePackageTotal()
    calculateExtraTotal()
    calculateExtraPackageTotal()
    calculateAllFee()
  })

  $('#tour-time').on('input', function () {
    let currentValue = parseInt($TourTimeInput.val())

    if (currentValue > maxValue) {
      $TourTimeInput.val(maxValue)
      $TourTimePlusButton.addClass('disabled')
      $TourTimeMinusButton.removeClass('disabled')
    } else if (currentValue < minValue) {
      $TourTimeInput.val(minValue)
      $TourTimePlusButton.removeClass('disabled')
      $TourTimeMinusButton.addClass('disabled')
    } else {
      $TourTimePlusButton.removeClass('disabled')
      $TourTimeMinusButton.removeClass('disabled')
    }
  })
  tourTimePriceUpdate()
  calculateAllFee()
})
